import React from 'react'
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle'
import { AlertsInformativos } from '../../components/generics/AlertsInformativos'
import { alertInformativo } from '../../commons/texts'
import { Divider } from '@mui/material'

export const CrearOrdenDeServicio = () => {
  return (
    <>
       
            <BreadCrumbsAndTitle
                title="Crear ordenes de servicio"
                mainModule="ordenes de servicio"
                parent="Crear ordenes de servicio"
                action=""
            />
            <AlertsInformativos
                type="info"
                title="info"
                content={alertInformativo.crearOrdenesServicios}
            />
            <Divider sx={{ marginBottom: 5 }} />


    </>
  )
}
